<div class="isolate flex -space-x-1 relative" (click)="click($event)">
  <div
    *ngFor="let sector of marketSectors | slice: 0 : 5; let i = index"
    class="relative inline-block h-6 w-6 rounded-full ring-2 ring-black bg-white p-1 cursor-pointer"
  >
    <img [src]="sector?.icon" alt="" />
  </div>
</div>
